/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const SmartphoneIcon = ({
  className,
  style,
  color = '#3a50f3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M14.4205 16.599V1.39734C14.4205 0.628805 13.7954 0 13.0232 0H4.97742C4.20888 0 3.58008 0.625128 3.58008 1.39734V16.6027C3.58008 17.3712 4.20521 18 4.97742 18H13.0232C13.7917 17.9963 14.4205 17.3712 14.4205 16.599ZM4.481 3.23963H13.5159V13.4697H4.481V3.23963ZM4.97742 0.900919H13.0232C13.2953 0.900919 13.5196 1.12155 13.5196 1.39734V2.33871H4.481V1.39734C4.481 1.12155 4.70531 0.900919 4.97742 0.900919ZM4.481 16.599V14.3669H13.5159V16.599C13.5159 16.8711 13.2953 17.0954 13.0195 17.0954H4.97742C4.70531 17.0954 4.481 16.8748 4.481 16.599Z"
        fill={color}
      />
      <path
        d="M9.91269 15.3193H8.08511C7.83506 15.3193 7.63281 15.5216 7.63281 15.7716C7.63281 16.0217 7.83506 16.2239 8.08511 16.2239H9.91269C10.1627 16.2239 10.365 16.0217 10.365 15.7716C10.365 15.5216 10.1627 15.3193 9.91269 15.3193Z"
        fill={color}
      />
    </svg>
  );
};
